import { createFileRoute } from '@tanstack/react-router';

import WpSiteControlLogin from 'component/view/Auth/WpSiteControlLogin';

export const Route = createFileRoute('/login/wpsitecontrol')({
  component: LoginWpSiteControlRoute,
});

function LoginWpSiteControlRoute() {
  return <WpSiteControlLogin />;
}
